import { gql } from '@apollo/client';

export const GET_EXTRACT_DATA_DESTINATIONS_OPTIONS = gql`
    query getExtractDataDestinationsOptions {
        extractDataDestinationsEnabled
    }
`;
